import controller from './PropertyDetailsCtrl';
import cssUtil from 'gw-portals-util-js/CssUtil';

import PropertyDetailsTemplate from 'text!./PropertyDetails.html';
import styles from './PropertyDetails-hashed.scss';

export default (function () {
    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(PropertyDetailsTemplate, styles),
        controller: controller,
        bindings: {
            incident: '=',
            cpPolicyExtension: '='
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/cp/directives/PropertyDetails/PropertyDetails.js
// module id = 1538
// module chunks = 0